// Node Module Imports
import React, { Component } from 'react'

import { FaTimes } from 'react-icons/fa'
import styled from 'styled-components'

// Component Imports
import { colors, space } from '../../style/design-system'
import Portal from './Portal'

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .button.sui-search-box__submit {
    font-size: 1.2rem;
    white-space: nowrap;
    padding: ${space.d} ${space.e};
  }
  .button.sui-search-box__submit {
    color: #fff;
    background-color: ${colors.umaDarkGreen};
    background-image: linear-gradient(-180deg,${colors.umaGreen},${colors.umaDarkGreen} 90%);
    &:hover {
      background-color: ${colors.umaDarkGreen};
      background-image: none;
      color: #fff;
    }
  }
`

const ModalCardWrap = styled.div`
  position: relative;
  background: white;
  // border: 6px solid ${colors.dev.blue.e()};
  border-radius: 2px;
  min-width: 40%;
  max-width: 900px;
  z-index: 10;
  box-shadow: ${space.a} ${space.a} .625rem rgba(0,0,0, 0.3);
  padding: ${space.f} 0;
  width: 90vw;
`

const ModalCard = styled.div`
  height: auto;
  max-height: 85vh;
  padding: 0 ${space.g};
  overflow: scroll;
`

const CloseButton = styled.button`
  background-color: ${colors.dev.blue.e()};
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  padding: .625rem;
  cursor: pointer;
  z-index: 9;
  transform: translate(50%, -50%);
`

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #111;
  opacity: 0.65;
`

export default class Modal extends Component {
  componentDidMount = () => {
    document.querySelector('body').classList.add('modal-open')
  }

  componentWillUnmount = () => {
    document.querySelector('body').classList.remove('modal-open')
  }

  closeModal = () => {
    this.props.closeModal()
  }

  render() {
    const { children } = this.props
    return (
      <Portal>
        <ModalWrapper>
          <ModalCardWrap>
            <CloseButton className="no-outline d-flex" onClick={this.closeModal}>
              <FaTimes color={colors.dev.blue.a()} name="close" />
            </CloseButton>
            <ModalCard>
              <div>{children}</div>
            </ModalCard>
          </ModalCardWrap>
          <Background onClick={this.closeModal} />
        </ModalWrapper>
      </Portal>
    )
  }
}
